import React from 'react'
import PropTypes from 'prop-types'

class TitleSection extends React.Component {
  constructor() {
    super()
  }

  render() {
    const findStudentHtml = ` <div onclick="$.meDialog.open2({'width': 800, 'url': '/instructor/search_student_dialog/${this.props.coursenum}/?source_page=instructor_progress', 'title': 'Find a Student', 'id': 'student_search_dialog'});" data-toggle='tooltip' data-placement='auto bottom' title='Search for a Student'>
      <button class="btn btn-myed btn-default btn-default-myed"><div class="fa-regular fa-search fa-fw mr-2"></div> Find a Student</button>
    </div> `
    return (
      <span>
        <div id="title_container">
          <div className="button_container pull-right text-right">
            <span dangerouslySetInnerHTML={{ __html: findStudentHtml }} />
          </div>
          <h1 className="me-course-title">{this.props.courseTitle}</h1>
          <h2 className="me-page-title">Student Analytics</h2>
        </div>
        <div className="clearfix" />
        <div className="vertical_spacer2" />
        <p>
          The purpose of this analytic is to find students that might be
          struggling or who need additional focus. Click the table headings to
          sort the table by reading progress, video progress, or assessment
          progress.
        </p>
      </span>
    )
  }
}

TitleSection.propTypes = {
  coursenum: PropTypes.string.isRequired,
  courseTitle: PropTypes.string,
  chapterFilter: PropTypes.string,
  studentFilter: PropTypes.string,
  senderFullName: PropTypes.string,
  numFilteredStudents: PropTypes.number,
}

export default TitleSection
